import { CNS_API_BASE } from "@/config";
import {
  CNSInnovationActionPage,
  CNSWorkspaceCreditBalance,
  CNSWorkspaceCreditLedgerEntryPage,
} from "@/models/cns";
import { throwOnProblemResponse } from "@/types/problem-detail";

export async function fetchWorkspaceCreditBalance(
  workspaceId: string
): Promise<CNSWorkspaceCreditBalance> {
  const res = await fetch(
    `${CNS_API_BASE}/workspaces/${encodeURIComponent(workspaceId)}/workspace-credit-account`,
    { credentials: "include" }
  );
  if (!res.ok) {
    await throwOnProblemResponse(res, "Failed to fetch credit balance");
  }
  return res.json();
}

export async function fetchWorkspaceCreditUsage(
  workspaceId: string,
  page = 0,
  size = 20
): Promise<CNSInnovationActionPage> {
  const params = new URLSearchParams({ page: String(page), size: String(size) });
  const res = await fetch(
    `${CNS_API_BASE}/workspaces/${encodeURIComponent(workspaceId)}/workspace-innovation-actions?${params.toString()}`,
    { credentials: "include" }
  );
  if (!res.ok) {
    await throwOnProblemResponse(res, "Failed to fetch credit usage");
  }
  return res.json();
}

export async function fetchWorkspaceCreditLedger(
  workspaceId: string,
  page = 0,
  size = 20
): Promise<CNSWorkspaceCreditLedgerEntryPage> {
  const params = new URLSearchParams({ page: String(page), size: String(size) });
  const res = await fetch(
    `${CNS_API_BASE}/workspaces/${encodeURIComponent(workspaceId)}/workspace-credit-ledger-entries?${params.toString()}`,
    { credentials: "include" }
  );
  if (!res.ok) {
    await throwOnProblemResponse(res, "Failed to fetch credit ledger");
  }
  return res.json();
}

